module.exports = __webpack_public_path__ + "static/Acta-Bold-675459c4ccd804ba798d979e3d9d48b2.woff";